import styles from './MainPrefaceTabletDesktopSize.module.scss'
import { textFactory } from 'src/locale/textFactory'
import Image from 'next/image'
import DecorationForTablet from 'public/images/codeit-enterance-decoration-M.svg'
import DecorationForDesktop from 'public/images/codeit-enterance-decoration-L.svg'

export default function MainPrefaceTabletDesktopSize() {
  const text = textFactory()
  return (
    <div className={ styles.MainPrefaceTabletDesktopSize }>
      <div className={ styles.sloganBox }>
        <div className={ styles.sloganCover }>
          <div className={ styles.circle }/>
          <Image
            src="/images/comma.svg"
            alt="Comma image"
            layout="fill"
            objectFit="cover"
            loader={ () => 'comma.svg' }
            unoptimized
          />
          <p className={ styles.slogan }>
            <span>{ text.MainPreface_slogan_Learn }</span>
            <br/>
            <span className={ styles.indent }>
              { text.MainPreface_slogan_to }
            </span>
            <br/>
            <span className={ styles.love }>
              { text.MainPreface_slogan_Love }
            </span>
            <br/>
            <span>{ text.MainPreface_slogan_Learning }</span>
          </p>
        </div>
        <div className={ styles.sloganDescriptionBox }>
          <div className={ styles.smallLine } />
          <div
            className={ styles.sloganDescription }
          >
            <p
              className={ styles.firstLine }
              dangerouslySetInnerHTML={ { __html: text.MainPreface_slogan_description_first } }
            />
            <p
              className={ styles.secondLine }
              dangerouslySetInnerHTML={ { __html: text.MainPreface_slogan_description_second } }
            />
            <p
              className={ styles.thirdLine } 
              dangerouslySetInnerHTML={ { __html: text.MainPreface_slogan_description_third } }
            />
            <p 
              className={ styles.fourthLine }
              dangerouslySetInnerHTML={ { __html: text.MainPreface_slogan_description_fourth } }
            />
          </div>
        </div>
      </div>
      <div className={ styles.enteranceImg }>
        <Image
          src="/images/codeit-enterance-ML.png"
          alt="Picture of codeit enterance"
          layout="fill"
          objectFit="cover"
          loader={ () => 'codeit-enterance.png' }
          unoptimized
        />
        <DecorationForTablet className={ styles.decorationForTablet }/>
        <DecorationForDesktop className={ styles.decorationForDesktop }/>
      </div>
    </div>
  )
}
